import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import {
  ArrayMaxSize,
  ArrayMinSize,
  IsArray,
  IsUUID,
  ValidateNested,
} from 'class-validator';
import {
  JobRepairPhotoItemDto,
  PHOTO_BATCH_MAX_ITEMS,
} from './job-repair-photo-item.dto';

/** Body of POST /job-repair-photo/batch. Returns the full photo list of the repair. */
export class JobRepairPhotoBatchDto {
  @ApiProperty({ format: 'uuid' })
  @Expose()
  @IsUUID('4')
  jobRepairId!: string;

  @ApiProperty({ type: () => [JobRepairPhotoItemDto] })
  @Expose()
  @IsArray()
  @ArrayMinSize(1)
  @ArrayMaxSize(PHOTO_BATCH_MAX_ITEMS)
  @ValidateNested({ each: true })
  @Type(() => JobRepairPhotoItemDto)
  photos!: JobRepairPhotoItemDto[];
}
